import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="footer-logo-wrap">
              <div className="footer-logo-icon">⚡</div>
              <div className="footer-logo-text">Last<span>Tech</span></div>
            </div>
            <p className="footer-about">Zimbabwe's premier tech gadget store. Smartphones, laptops, audio, wearables & accessories. Fast delivery. Genuine products. Personal service.</p>
            <div className="footer-contact-item"><span className="footer-contact-icon">👤</span><span>Last Maisiri — Owner</span></div>
            <div className="footer-contact-item"><span className="footer-contact-icon">📍</span><span>Bindura, Mashonaland Central, Zimbabwe</span></div>
            <div className="footer-contact-item"><span className="footer-contact-icon">📞</span><a href="tel:+263713508064">+263 713 508 064</a></div>
            <div className="footer-contact-item"><span className="footer-contact-icon">📱</span><a href="https://wa.me/263713508064" target="_blank" rel="noreferrer">WhatsApp: +263 713 508 064</a></div>
            <div className="footer-social">
              <a href="https://wa.me/263713508064" target="_blank" rel="noreferrer" className="social-btn">📱</a>
              <a href="#" className="social-btn">📘</a>
              <a href="#" className="social-btn">📸</a>
              <a href="#" className="social-btn">🐦</a>
            </div>
          </div>
          <div>
            <div className="footer-h4">Quick Links</div>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">All Products</Link></li>
              <li><Link to="/deals">Hot Deals</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <div className="footer-h4">Categories</div>
            <ul className="footer-links">
              <li><Link to="/products">Smartphones</Link></li>
              <li><Link to="/products">Laptops & PCs</Link></li>
              <li><Link to="/products">Audio</Link></li>
              <li><Link to="/products">Smart Watches</Link></li>
              <li><Link to="/products">Tablets</Link></li>
              <li><Link to="/products">Accessories</Link></li>
            </ul>
          </div>
          <div>
            <div className="footer-h4">Customer Care</div>
            <ul className="footer-links">
              <li><a href="#">Returns Policy</a></li>
              <li><a href="#">Warranty Info</a></li>
              <li><a href="#">Delivery Info</a></li>
              <li><a href="#">Track Order</a></li>
              <li><a href="#">FAQ</a></li>
            </ul>
            <div style={{ marginTop: '1.5rem' }}>
              <a href="https://wa.me/263713508064?text=Hi%20Last!%20I%20need%20help" target="_blank" rel="noreferrer" className="btn btn-wa btn-sm" style={{ display: 'flex', justifyContent: 'center' }}>
                📱 Chat with Last
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-copy">© 2024 LASTTECH — LAST MAISIRI · BINDURA, ZIMBABWE · +263 713 508 064</div>
          <div className="footer-payment">
            <span className="pay-badge">ECOCASH</span>
            <span className="pay-badge">ONEMONEY</span>
            <span className="pay-badge">USD CASH</span>
            <span className="pay-badge">ZIMDOLLAR</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
